import React from 'react';
import { Title } from 'components/Toolbar/constants';
import { CharStyle } from 'const';
import { IconType } from '../../../Icon/constants';
import EditorToolbarButton from '../EditorToolbarButton';
import styles from './styles.module.scss';

const CHAR_STYLES = [
  { label: IconType.TOOLBAR_BOLD, style: CharStyle.BOLD, title: Title.FONT_DECORATION_BOLD },
  { label: IconType.TOOLBAR_ITALIC, style: CharStyle.ITALIC, title: Title.FONT_DECORATION_ITALIC },
  { label: IconType.TOOLBAR_UNDERLINE, style: CharStyle.UNDERLINE, title: Title.FONT_DECORATION_UNDERLINE },
];

type Props = {
  activeStyles: CharStyle[];
  onToggle: (style: CharStyle) => void;
  dataTestId?: string;
};

const CharStyleControl: React.FunctionComponent<Props> = (props) => {
  const {
    activeStyles = [],
    onToggle,
    dataTestId = 'charStyleControl',
  } = props;

  return (
    <div className={styles.CharStyleControl} data-testid={dataTestId}>
      {CHAR_STYLES.map((type, index) => (
        <EditorToolbarButton<CharStyle>
          key={type.label}
          active={activeStyles.includes(type.style)}
          label={type.label}
          onToggle={onToggle}
          value={type.style}
          title={type.title}
          dataTestId={`${dataTestId}-control${index}`}
        />
      ))}
    </div>
  );
};

export default CharStyleControl;
